"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.38 12.508a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m1.5-2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.38 4C8.665 4 6 7.249 6 10.756v.015c.055 1.805.887 3.684 1.94 5.257 1.055 1.575 2.377 2.912 3.495 3.618.578.365 1.309.37 1.89 0 1.11-.705 2.43-2.061 3.486-3.644 1.054-1.58 1.893-3.46 1.948-5.23v-.016c0-3.512-2.746-6.756-6.38-6.756M8.77 15.472C7.773 13.98 7.05 12.289 7 10.749 7.004 7.702 9.311 5 12.38 5c2.996 0 5.375 2.706 5.379 5.749-.049 1.502-.777 3.194-1.78 4.698s-2.231 2.745-3.19 3.356a.76.76 0 0 1-.82-.002c-.97-.613-2.199-1.837-3.198-3.329"
  })]
}), 'MapPin');
//# sourceMappingURL=index.js.map